tindie.navigation = (function (t, $) {
	var ads = tindie.ads;
	t.lock = true;
	t.view = function (vm) {
		var self = this;
		tindie.app.base.call(self);
		self.sortBy = ko.observable().extend({
			rateLimit: 500
		});
		self.sortBy.subscribeChanged(function (currentSort, prevSort) {
			if (typeof (prevSort) !== "undefined") {
				$('#product-list-sort').submit();
			}
		});
		self.changeCountry = ko.observable(false).toggleable();
		self.selectedCountry = ko.computed(function () {
			return (self.country() !== "None" && !self.changeCountry());
		});
	};
	t.init = function () {
		var page = tindie.app.getPage();
		if (page == "sale" || page == "open_hardware" || page == "newest") {
			page = "list";
		}
		tindie.navigation[page] != undefined && tindie.navigation[page].init();
		self.trackClick = function () {
			return ads.trackClick();
		}
		$('.country-select').on('change', function (ev) {
			ev.preventDefault();
			var countryForm = $(this).parents('form.set-country');
			$.ajax({
				type: 'POST',
				url: countryUrl,
				dataType: 'json',
				data: countryForm.serialize(),
				success: function (result) {
					if (result.valid == true) {
						window.location.reload(false);
					}
				},
				error: function (status, data) { }
			});
		});
		$('#country-change').on('click', function (ev) {
			var the_span = $(this).parent();
			the_span.addClass('hide');
			the_span.prev('span.page-info').find('.ship-to-country').addClass('hide');
			$('.set-country').removeClass('hide');
		});
		$('#country-clear').on('click', function (ev) {
			ev.preventDefault();
			$.ajax({
				type: 'POST',
				url: clearCountryUrl,
				success: function (result) {
					if (result.valid == true) {
						window.location.reload(false);
					}
				},
				error: function (status, data) { }
			});
		});
		$('#filter-collapse').on('show.bs.collapse', function () {
			$(this).removeClass('hidden-xs hidden-sm');
		});
	}
	return t;
})(tindie.navigation || {}, jQuery);